import { render, staticRenderFns } from "./YApplyCardServiceDialog.vue?vue&type=template&id=222784fa&scoped=true"
import script from "./YApplyCardServiceDialog.vue?vue&type=script&lang=js"
export * from "./YApplyCardServiceDialog.vue?vue&type=script&lang=js"
import style0 from "./YApplyCardServiceDialog.vue?vue&type=style&index=0&id=222784fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222784fa",
  null
  
)

export default component.exports